import React from 'react';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, PieChart, Pie, Cell, Legend } from 'recharts';
import './StatCards.css';

const COLORS = ['#16a34a', '#16a34a', '#ea580c', '#7c3aed', '#dc2626', '#0d9488', '#ca8a04'];

function StatCards({ items = [], charts = [] }) {
  return (
    <div className="sc-wrap">
      <div className="sc-grid">
        {items.map(([label, value, color], i) => (
          <div key={label} className="sc-card" style={{ borderTopColor: color || COLORS[i % COLORS.length] }}>
            <div className="sc-value">{value}</div>
            <div className="sc-label">{label}</div>
          </div>
        ))}
      </div>
      {charts.length > 0 && charts.filter(c => c.data && c.data.some(d => d.value > 0)).length === 0 && (
        <div className="sc-charts">
          <div className="sc-chart sc-empty">
            <span className="sc-empty-icon">📊</span>
            <span>No data yet</span>
          </div>
        </div>
      )}
      {charts.filter(c => c.data && c.data.some(d => d.value > 0)).length > 0 && (
        <div className="sc-charts">
          {charts.filter(c => c.data && c.data.some(d => d.value > 0)).map(c => (
            <div key={c.title} className="sc-chart">
              <h4>{c.title}</h4>
              <ResponsiveContainer width="100%" height={200}>
                {c.type === 'pie' ? (
                  <PieChart>
                    <Pie data={c.data} dataKey="value" nameKey="name" outerRadius={65}>
                      {c.data.map((d, i) => <Cell key={d.name} fill={d.color || COLORS[i % COLORS.length]} />)}
                    </Pie>
                    <Tooltip />
                    <Legend formatter={(value, entry) => `${value} (${entry.payload?.value ?? 0})`} />
                  </PieChart>
                ) : (
                  <BarChart data={c.data}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" tick={{ fontSize: 11 }} interval={0} />
                    <YAxis allowDecimals={false} />
                    <Tooltip />
                    <Bar dataKey="value" radius={[4, 4, 0, 0]}>
                      {c.data.map((d, i) => <Cell key={d.name} fill={d.color || COLORS[i % COLORS.length]} />)}
                    </Bar>
                  </BarChart>
                )}
              </ResponsiveContainer>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default StatCards;
